import { loadPageWebpack } from './legacy-bootstrap-utils';
import { withPrefetch } from '../components/utils';

const importPage = () => import(/* webpackMode: "eager" */ '@bingads-webui-campaign-react/campaigns-page');

const prefetchChunks = () => {
  import(/* webpackChunkName: "campaign-onboarding-v2-page" */ '../feature-bootstrap/campaign-onboarding-v2-page');
};

const Feature = loadPageWebpack({
  importFeature: () => importPage()
    .then(({ StyledCampaigns }) => withPrefetch(StyledCampaigns, prefetchChunks)),
  importL10n: () => import(/* webpackChunkName: "campaigns-page.dynamic.l10n" */'./campaigns-page.l10n'),
  hasLegacyI18n: true,
});

export default Feature;
